import React, { useState, useEffect } from "react"
import { getSituazionePagamenti } from "../../services/endpoints";
import { showProgress, moveFocusTo } from "../../utils/elements";
import * as Constants from '../../utils/constants'
import {
  Container,
  Row,
  Col,
  Button,
  Alert,
  Icon
} from 'design-react-kit';

export const SibaMostraSituazionePagamenti = ({ _veicolo, _handleSubmit, _handleBack }) => {

  const [situazionePagamenti, setSituazionePagamenti] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const [isAlertNonPagabileOpen, setAlertNonPagabileOpen] = useState(false);
  const [causaleNonPagabile, setCausaleNonPagabile] = useState('');

  const [isAlertPagatoOpen, setAlertPagatoOpen] = useState(false);
  const [causalePagato, setCausalePagato] = useState('');

  const [isAlertNonPagatoOpen, setAlertNonPagatoOpen] = useState(false);
  const [causaleNonPagato, setCausaleNonPagato] = useState('');

  useEffect(() => {
    loadInfoPagamento(_veicolo);
  }, [])

  useEffect(() => {
    moveFocusTo("chiudi_elenco");
  })

  const loadInfoPagamento = async (veicolo) => {
    var annoDiInizioRicerca = new Date().getFullYear() - Constants.ULTIMI_TRE_ANNI;
    const responseSituazionePagamenti = await getSituazionePagamenti(annoDiInizioRicerca, veicolo.idVeicolo, veicolo.idProprietario);
    if (responseSituazionePagamenti === undefined) {
      console.log('Pagamenti dal %s per veicolo %s non trovati', annoDiInizioRicerca, veicolo.idVeicolo)
      setSituazionePagamenti([])
      setLoading(false)
      return
    }
    setSituazionePagamenti(responseSituazionePagamenti)
    setLoading(false)
  }

  const handleSubmit = (dati) => { _handleSubmit(dati) }

  const isPagabile = (schedaPagamento) => {
    return schedaPagamento.isPagabile && schedaPagamento.isCalcolabile;
  }

  const isRimborsabile = (schedaPagamento) => {
    return !schedaPagamento.isPagabile && !schedaPagamento.isCalcolabile;
  }

  const buildPulsantePerRigaTabella = (schedaPagamento) => {
      return (
        <div>
          <Button
            className="btn btn-success mr-2"
            size="xs"
            color="primary"
            icon={false}
            tag="button"
            onClick={() => handleSubmit({ schedaPagamento: schedaPagamento, choice: Constants.RIM_CHOICE_PAGAMENTO_VISUALIZZA })}
          > Visualizza
          </Button>
          {/*<Button
            className="btn btn-light"
            size="xs"
            icon={true}
            tag="button"
            onClick={() => toggleAlertPagato(schedaPagamento)}
          > &nbsp;?&nbsp;
        </Button> */}
        </div>
      )
  }

  const toggleAlertNonPagabile = (schedaPagamento) => {
    let message = "Anno " + schedaPagamento.anno + " non pagabile: ";
    if (schedaPagamento.risultato.includes("-")) {
      message += schedaPagamento.risultato.split(" - ")[1];
    } else {
      message += schedaPagamento.risultato;
    }
    setCausaleNonPagabile(message)
    setAlertNonPagabileOpen(!isAlertNonPagabileOpen);
  }

  const toggleAlertPagato = (schedaPagamento) => {
    let message = "Anno " + schedaPagamento.anno + ": ";
    if (schedaPagamento.risultato.includes("-")) {
      message += schedaPagamento.risultato.split(" - ")[1];
    } else {
      message += schedaPagamento.risultato;
    }
    setCausalePagato(message)
    setAlertPagatoOpen(!isAlertPagatoOpen);
  }

  const toggleAlertNonPagato = (schedaPagamento) => {
    let message = "Anno " + schedaPagamento.anno + " da rettificare: ";
    if (schedaPagamento.risultato.includes("-")) {
      message += schedaPagamento.risultato.split(" - ")[1];
    } else {
      message += schedaPagamento.risultato;
    }
    setCausaleNonPagato(message)
    setAlertNonPagatoOpen(!isAlertNonPagatoOpen);
  }

  const isOwned = (schedaPagamento) => {
    return (
      //starest: "AUTO NON ANCORA DI PROPRIETA"
      !schedaPagamento.risultato.includes("NON ANCORA")
      //stacobon: "Non trovato ingresso in Regione in tempo utile"
      && !schedaPagamento.risultato.includes("Non trovato")
      //stacobon: "Trovata uscita da Regione in tempo utile"
      && !schedaPagamento.risultato.includes("Trovata uscita")
    )
  }

  const buildTableRow = (schedaPagamento) => {
    if (!isOwned(schedaPagamento)) {
      return (React.Fragment)
    }

    return (
      <tr key={schedaPagamento.anno}>
        <td class="align-middle text-center">{schedaPagamento.anno}</td>
        <td class="align-middle text-center">{schedaPagamento.targa}</td>
        <td class="align-middle text-center">{buildPulsantePerRigaTabella(schedaPagamento)}</td>
      </tr>
    )
  }

  const showAlertNonPagabile = () => { return isAlertNonPagabileOpen ? <Alert color="info" > {causaleNonPagabile} </Alert> : React.Fragment; }
  const showAlertPagato = () => { return isAlertPagatoOpen ? <Alert color="success" > {causalePagato} </Alert> : React.Fragment; }
  const showAlertNonPagato = () => { return isAlertNonPagatoOpen ? <Alert color="danger" > {causaleNonPagato} </Alert> : React.Fragment; }

  //START RENDERING

  if (isLoading) { return showProgress() }

  return (
    <Container className="px-2 my-2" id="situazioneVeicoli" tag="section">
      <Alert color="info" >
          ATTENZIONE: &egrave; possibile consultare la situazione degli ultimi {Constants.ULTIMI_TRE_ANNI + 1} anni,  tranne i pagamenti relativi al ruolo.<br/>
          Per gli anni pregressi rivolgersi agli uffici <strong>ACI</strong> <em>(indirizzi e num. telefono presenti in <a target="_blank" href="https://servizi.regione.liguria.it/page/welcome/BOLLO_AUTO/Contatti?idinformazione=227">questa pagina Contatti </a>)</em>
       </Alert>
      {showAlertNonPagabile()}
      {showAlertPagato()}
      {showAlertNonPagato()}
      <Row>
        <Col>
          <h3>{Constants.STR_RIMBORSI_TITOLO_ELENCO_PAGAMENTI}</h3>
          <table className="table table-striped table-sm">
            <thead className="thead-light">
              <tr>
                <th className="align-middle text-center">Anno di imposta</th>
                <th className="align-middle text-center">Targa</th>
                <th className="align-middle text-center">Dettagli</th>
              </tr>
            </thead>
            <tbody>
              {situazionePagamenti.map((schedaPagamento) => (
                buildTableRow(schedaPagamento)
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
      <Button
        id="chiudi_elenco"
        className="btn btn-primary"
        size="xs"
        color="primary"
        icon={false}
        tag="button"
        onClick={_handleBack}
      > Chiudi
      </Button>
    </Container>
  )
}

export default SibaMostraSituazionePagamenti;